// Release 2 (F2): helpers for showing database text inside v-html without letting it run as HTML.

const HTML_ESCAPES = { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" };

// Turn any value into text that a browser shows literally (no tags, no scripts).
export function escapeHtml(value) {
  if (value === null || value === undefined) return "";
  return String(value).replace(/[&<>"']/g, c => HTML_ESCAPES[c]);
}

// Make typed text safe to use inside a RegExp ("(" or "[" no longer break the search).
export function escapeRegExp(value) {
  return String(value).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

// Bold every part of `text` that matches one of the words typed in `query`.
// Words are split on spaces, - _ / \ | and . (as before). The result is safe HTML:
// the text is escaped and the only tags added are <b></b>.
export function boldenMatches(text, query) {
  const raw = text === null || text === undefined ? "" : String(text);
  const words = String(query || "")
    .split(/[\s\-_/\\|.]/)
    .filter(w => !!w)
    .map(escapeRegExp);
  if (!words.length) return escapeHtml(raw);
  const re = new RegExp("(" + words.join("|") + ")", "gi");
  return raw
    .split(re)
    .map((part, i) => (i % 2 ? "<b>" + escapeHtml(part) + "</b>" : escapeHtml(part)))
    .join("");
}
